import { SchemaProperty } from 'types/schema';

/**
 * Filters out properties that have the hidden flag set to true.
 * This ensures consistent behavior across all UI components that display properties.
 * 
 * @param properties - Array of schema properties
 * @returns Array of properties with hidden properties filtered out
 */
export function filterHiddenProperties(properties: SchemaProperty[]): SchemaProperty[] {
  if (!properties || !Array.isArray(properties)) {
    return [];
  }

  return properties.filter(property => {
    // Cast to any to access hidden property, as it might not be in strict types yet
    const hiddenProperty = (property as any).hidden;
    return hiddenProperty !== true;
  });
}

/**
 * Filters out properties that have the hidden flag set to true, excluding specific property names.
 * Useful for filtering additional properties while preserving core properties.
 * 
 * @param properties - Array of schema properties
 * @param excludeNames - Array of property names to always exclude (e.g., ['name', 'type', 'description'])
 * @returns Array of properties with hidden properties and excluded names filtered out
 */
export function filterHiddenPropertiesExcluding(
  properties: SchemaProperty[], 
  excludeNames: readonly string[]
): SchemaProperty[] {
  if (!properties || !Array.isArray(properties)) {
    return [];
  }

  return properties.filter(property => {
    // First filter by excluded names
    if (excludeNames.includes(property.name)) {
      return false;
    }
    
    // Then filter by hidden flag
    const hiddenProperty = (property as any).hidden;
    return hiddenProperty !== true;
  });
}